// @todo Types were taken from frontend/apps/b2c-domru/src/api/content/shop/getShopItems.ts
// and deeper components, need to collect all them only in api-domru package now, to not cross dependencies from b2c-domru/src/api/content…
export enum EPriceTypes {
    Possess = 1,
    Leasing = 5,
}

export enum EShopCategory {
    Antiviruses = 'antiviruses',
    SpeedBonuses = 'speed-bonuses',
    Routers = 'routers',
    Intercom = 'intercom',
    Sale = 'special-offers',
    PartnerServices = 'partner-service-with-phone-check',
    Decoders = 'decoders',
    BonusToAll = 'bonus-to-all',
    YandexStation = 'yandex-stanciya',
    YandexStationLite = 'yandex-stanciya-lite',
    SafeKids = 'safe-kids',
    LoyaltyProgram = 'loyalty-program',
    Products = 'products',
    Subscriptions = 'subscriptions',
    Multibundle = 'multibundle',
    Videocontrol = 'videocontrol',
}

export enum EExpandShopItems {
    Advertising = 'advertising',
    Category = 'category',
    Props = 'props',
    Labels = 'labels',
    CategoryProps = 'category.props',
}

export interface IShopEquipmentProp {
    id: number,
    name: string,
    title: string,
    default_value: string | null,
    field_type: string,
    as_is: number,
    import_field?: string,
    options?: string,
    import_suffix?: string,
}

export interface IShopCategory {
    id: number,
    parent_id: number | null,
    parentName: string | null, // Заполнено если есть родительская категория
    name: EShopCategory,
    image: string | null,
    show_in_catalog: number,
    text_fail: string,
    text_success: string,
    title: string,
    type_id: number,
    button_text: string,
    button_text_exists: string,
    buy_by_call: number,
    buy_with_check_phone: number,
    how_it_works: string,
    why_it_is_easy: string,
    props?: IShopEquipmentProp[],
    [key: string]: unknown,
}

export interface IPartnerVasContents {
    content_type_id: number,
    is_active: number,
    is_included_agr: number,
    is_need_phone: number,
    name: string,
    price: number,
    service_id: number,
    soc_id: number,
}

export interface IShopLabel {
    id: number,
    name: string,
    title: string,
    color: string,
    color_text: string,
}

export interface IShopProp {
    name: string,
    title: string,
    type: string,
    value?: string | string[],
    computedValue?: string,
    asIs?: number,
}

export interface ICostRa {
    dur_type_id: number,
    duration: number,
    flag_ra: number,
    cost: number,
}

export interface IShopPriceOptions {
    label: string,
    price: number,
    pricePromo?: number,
    type: EPriceTypes.Possess | EPriceTypes.Leasing,
    operType: string,
}

export interface IShopPriceV2 {
    sort: number,
    type: number,
    date_close_promo: string | null,
    duration: number | null,
    id: number,
    lifetime_price: number | null,
    owner_id: number,
    price_type: string,
    value: number,
}

export interface IUrl {
    id: number,
    manual: number,
    name: string,
    owner_id: number,
    type: string,
    url: string,
}

export interface IAdvertising {
    companyName: string,
    erid: string,
}

export interface IShopItem {
    advertising: IAdvertising | null,
    alias: string,
    body: string,
    body_full: string,
    button_link: string,
    button_text: string,
    category_id: number,
    exists: boolean,
    extra: unknown[],
    global_id: number,
    id: number,
    image: string,
    image_webp?: string,
    images: string[],
    costRa: ICostRa[],
    // 0 или 1
    is_sale: number,
    prices: IShopItemPrices,
    pricesV2: IShopPriceV2[],
    pricesPromo: IShopItemPrices,
    sort: null | number,
    title: string,
    title_short?: string,
    labels?: IShopLabel[],
    category?: IShopCategory,
    image_widgets?: string,
    image_widgets_background?: string,
    image_background?: string,
    image_background_webp?: string,
    image_for_tariff_card: string,
    image_for_tariff_card_webp?: string,
    image_for_tariff_card_height: number,
    image_for_tariff_card_width: number,
    props?: IShopProp[],
    priceOptions?: IShopPriceOptions[],
    partnerVasContents?: IPartnerVasContents,
    image_width?: number,
    image_height?: number,
    leftovers: number | null,
    showForDelivery?: 0 | 1 | null,
    checkProductId?: number,
    name: string,
    urls?: IUrl[],
}

interface IMonth {
    value: number,
    lifetime_price: number,
}

interface IRent {
    month: IMonth | null,
    year: number | null,
}

export interface IShopItemPrices {
    leasing?: ILeasing[],
    possess?: number,
    rent?: IRent,
}

export interface ILeasing {
    price: number,
    duration: number,
}
